import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/material/")({
  loader: () => {
    throw redirect({
      to: "/dashboard/material/new/select-subject",
    });
  },
});
